import * as React from "react";
import { Appointment } from "@teamprevent/common/calendar";

import { connect } from "react-redux";

import { Modal, Loader } from "semantic-ui-react";

import { PartialOhCaseDetailModel, OhCaseState } from "../../crud/ohCase";
import { ApplicationState } from "../models";
import { selectedAppointmentSelector } from "../selectors";

import { TimeNoteAppointmentModal } from "../timeNotes/components/TimeNoteAppointmentModal";

import { OhCaseAppointmentModal } from "./OhCaseAppointmentModal";

interface AppointmentModalOwnProps {
    onModalClose: () => void;
}

interface AppointmentModalStateProps {
    ohCase: PartialOhCaseDetailModel | undefined;
    selectedAppointment: (Appointment & { id?: string }) | undefined;
    isModalOpen: boolean;
}

class AppointmentModalUnconnected extends React.Component<AppointmentModalOwnProps & AppointmentModalStateProps> {
    constructor(props: AppointmentModalOwnProps & AppointmentModalStateProps) {
        super(props);
    }
    public render() {
        if (!this.props.selectedAppointment) {
            return (
                <Modal open={this.props.isModalOpen} onClose={this.props.onModalClose} closeIcon>
                    <Modal.Content>
                        <Loader active inline="centered" content="Loading" />
                    </Modal.Content>
                </Modal>
            );
        } else if ("ohCaseId" in this.props.selectedAppointment && typeof this.props.selectedAppointment.ohCaseId === "string") {

            if (!this.props.ohCase) {
                return null;
            }

            return (
                <OhCaseAppointmentModal
                    onModalClose={this.props.onModalClose}
                    ohCase={this.props.ohCase}
                    selectedAppointment={this.props.selectedAppointment}
                    isModalOpen={this.props.isModalOpen}
                />
            );
        }

        return (<TimeNoteAppointmentModal
            onModalClose={this.props.onModalClose}
            selectedAppointment={this.props.selectedAppointment}
            isModalOpen={this.props.isModalOpen}
        />);
    }
}

const mapStateToProps = (state: ApplicationState & OhCaseState): AppointmentModalStateProps => {
    const selectedAppointment = selectedAppointmentSelector(state);
    return {
        ohCase: state.ohCases && selectedAppointment && state.ohCases.find(c => c.id === selectedAppointment.ohCaseId),
        selectedAppointment,
        isModalOpen: !!(state.router.params && state.router.params.appointmentId)
    };
};

export const AppointmentModal = connect(mapStateToProps)(AppointmentModalUnconnected);
